module.exports = __webpack_public_path__ + "static/img/COVER-3.893f2df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/COVER-3.png
// module id = 1hq5
// module chunks = 31